// extracted by mini-css-extract-plugin
export default {"Telephone":"Telephone_Telephone__FT4Ro","AriaDescription":"Telephone_AriaDescription__t--XP","PhoneInput":"Telephone_PhoneInput__u3d4e"};